<div class="system-settings-root" *transloco="let t">
  <div class="page-header">
    <div class="page-title-desktop">
      <app-header [hasDashedLine]="false">{{t('system-settings')}}</app-header>
      <app-label isGray>{{ t('points-expiration-period-field') }}</app-label>
    </div>
    <div class="update-button-content">
      <div class="current-expiration">
        <span>{{labels.currentRuleTitle}}</span>
        <span *ngIf="currentActiveSystemSettings.fixedExpirationDate">
          {{labels.fixedExpirationDateDescription}}
        </span>
        <span *ngIf="!currentActiveSystemSettings.fixedExpirationDate">
          {{currentActiveSystemSettings.pointExpirationPeriodMonths }} {{labels.monthPrefix}}
        </span>
      </div>
      <app-primary-button v2Outlined (clickAction)="openScheduledModal()">{{labels.updateBtn}}</app-primary-button>
    </div>
  </div>
  <div class="dashed-line"></div>

  <div
    class="history-table-content"
    *ngIf="systemSettingsHistory.length"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    [scrollWindow]="false"
    [immediateCheck]="true"
    (scrolled)="pageControllerLoad()"
  >
    <div class="history-table-header-line">
      <div class="history-table-column">
        {{ tableHeaderLabels.tablePeriod }}
      </div>
      <div class="history-table-status-column">
        {{ tableHeaderLabels.tableSchedule }}
      </div>
      <div class="history-table-column">
        {{ tableHeaderLabels.tableUpdatedBy }}
      </div>
      <div class="history-table-status-column">
        {{ tableHeaderLabels.tableUpdateDate }}
      </div>
      <div class="history-table-status-column">
        {{ tableHeaderLabels.tableStatus }}
      </div>
      <div class="history-table-action-column">
        {{ tableHeaderLabels.tableActions }}
      </div>
    </div>
    <div *ngFor="let item of systemSettingsHistory;" class="history-table-content-line">
      <div class="history-table-column" *ngIf="!item.fixedExpirationDate">
        {{ item.pointExpirationPeriodMonths }} months
      </div>
      <div class="history-table-column" *ngIf="item.fixedExpirationDate">
        {{labels.fixedExpirationDateDescription}}
      </div>
      <div class="history-table-status-column">
        {{ item.pointsExpirationEffectiveDate | date: 'MM.dd.YYYY' }}
      </div>
      <div class="history-table-column">
        {{ item.updatedBy }}
      </div>
      <div class="history-table-status-column">
        {{ item.lastUpdateDate | date: 'MM.dd.YYYY' }}
      </div>
      <div class="history-table-status-column">
        <app-status [status]="item.status"></app-status>
      </div>
      <div class="history-table-action-column">
        <app-icon-click
          small
          [disabled]="item.status !== 'SCHEDULED'"
          (click)="openScheduledModal(item)"
        >calendar_month</app-icon-click>
        <app-icon-click
          small
          [disabled]="item.status !== 'SCHEDULED'"
          (click)="openConfirmDeleteScheduledModal(item)"
        >clear</app-icon-click>
      </div>
    </div>
  </div>

  <mat-spinner
    *ngIf="loading"
    class="loading"
    diameter="50"
  ></mat-spinner>

</div>
